import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { api } from "../lib/api";
import PageHero from "../components/PageHero";
import InstagramReels from "../components/InstagramReels";

export default function Gallery() {
  const [images, setImages] = useState([]);
  useEffect(() => {
    api.get("/gallery").then((r) => setImages(r.data)).catch(() => {});
  }, []);

  return (
    <div data-testid="gallery-page">
      <PageHero
        overline="Life at SVS"
        title={<>Moments of <span className="italic text-gold-gradient">learning</span> & care</>}
        subtitle="A glimpse into our campus, laboratories, clinical training and student life."
      />
      <section className="bg-sand py-24">
        <div className="max-w-7xl mx-auto px-5 sm:px-8">
          <div className="columns-1 sm:columns-2 lg:columns-3 gap-6 space-y-6">
            {images.map((img, i) => (
              <motion.div
                key={img.id}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.7, delay: (i % 3) * 0.1 }}
                className="group relative overflow-hidden rounded-[2px] break-inside-avoid"
                data-testid={`gallery-item-${i}`}
              >
                <img src={img.url} alt={img.caption} loading="lazy" className="w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                <div className="absolute inset-0 bg-gradient-to-t from-navy/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 flex items-end p-5">
                  <div>
                    <span className="text-gold text-xs tracking-widest uppercase font-mono">{img.category}</span>
                    <p className="text-sand font-serif text-lg">{img.caption}</p>
                  </div>
                </div>
                <div className="absolute inset-0 ring-1 ring-inset ring-gold/20" />
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <InstagramReels />
    </div>
  );
}
